// ** React Imports
import { Fragment, useState } from 'react';

// ** Third Party Components
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Eye, EyeOff } from 'react-feather';
import {
  InputGroup,
  InputGroupAddon,
  Input,
  InputGroupText,
  Label,
} from 'reactstrap';
import { isIOS, isMobile } from 'react-device-detect';

const InputPasswordToggle = (props) => {
  // ** Props
  const {
    label,
    hideIcon,
    showIcon,
    visible,
    className,
    htmlFor,
    placeholder,
    iconSize,
    innerRef,
    invalid,
    name,
    id,
    ...rest
  } = props;

  // ** State
  const [inputVisibility, setInputVisibility] = useState(visible);

  // ** Renders Icon Based On Visibility
  const renderIcon = () => {
    const size = iconSize || 14;

    if (inputVisibility === false) {
      return hideIcon || <Eye size={size} />;
    }
    return showIcon || <EyeOff size={size} />;
  };

  return (
    <>
      {label ? <Label for={htmlFor}>{label}</Label> : null}
      <InputGroup
        className={classnames({
          [className]: className,
        })}
      >
        <Input
          type={inputVisibility === false ? 'password' : 'text'}
          placeholder={placeholder || '············'}
          /*eslint-disable */
          {...(label && htmlFor
            ? {
                id: htmlFor,
              }
            : {
                id,
              })}
          {...rest}
          innerRef={innerRef}
          style={isMobile && isIOS ? { fontSize: 16 } : {}}
          name={name}
          invalid={invalid}
          /* eslint-enable */
        />
        <InputGroupAddon
          addonType="append"
          onClick={() => setInputVisibility(!inputVisibility)}
        >
          <InputGroupText className="cursor-pointer">
            {renderIcon()}
          </InputGroupText>
        </InputGroupAddon>
      </InputGroup>
    </>
  );
};

export default InputPasswordToggle;

// ** PropTypes
InputPasswordToggle.propTypes = {
  hideIcon: PropTypes.node,
  showIcon: PropTypes.node,
  visible: PropTypes.bool,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  id: PropTypes.string,
  iconSize: PropTypes.number,
  innerRef: PropTypes.func,
  name: PropTypes.string,
  invalid: PropTypes.any,
  label(props, propName, componentName) {
    // ** If label is defined and htmlFor is undefined throw error
    if (props[propName] && props.htmlFor === 'undefined') {
      throw new Error('htmlFor prop is required when label prop is present');
    }
  },
  htmlFor(props, propName, componentName) {
    // ** If htmlFor is defined and label is undefined throw error
    if (props[propName] && props.label === 'undefined') {
      throw new Error('label prop is required when htmlFor prop is present');
    }
  },
};

// ** Default Props
InputPasswordToggle.defaultProps = {
  visible: false,
};
